import "./styles.scss";

export default {
  name: "MessagingAvailableMessagesPage",

  data() {
    return {
      activeTab: "preset", // ✅ default tab
    };
  },

  computed: {
    subscription() {
      return this.$store.state.subscriptions.active_subscription;
    },

    buildingMessages() {
      return this.$store.getters.getBuildingMessages;
    },

    presetMessages() {
      return this.$store.getters.getPresetMessages || [];
    },

    customMessages() {
      return this.$store.getters.getCustomMessages || [];
    },
    visibleMessages() {
      return this.activeTab === "preset"
        ? this.presetMessages
        : this.customMessages;
    },
  },

  created() {
    this.$store.commit("setMenuDetails", {
      title: "Emergency Messages",
      slug: "messaging",
      back_url: "/action/emergency-messages/choose-message",
    });

    this.$store.dispatch("fetchBuildingProfile");
  },

  methods: {
    update(item) {
      this.$store.commit("setMessage", item.title);

      this.$router.push("/action/emergency-messages/compose-message");
    },

    cancel() {
      this.$ionic.alertController
        .create({
          header: "Are you sure you want to cancel?",
          message: "This action cannot be undone.",
          buttons: [
            {
              text: "Yes",
              handler: () => {
                this.$store.commit("resetMessage");
                this.$router.push("/action");
              },
            },
            {
              text: "No",
              role: "cancel",
            },
          ],
        })
        .then((a) => a.present());
    },
    editMessage(item) {
      console.log("Edit message:", item);
      // Add your edit logic here
      this.$ionic.alertController
        .create({
          header: "Edit Message",
          cssClass: "edit-message-alert", // Custom CSS class
          inputs: [
            {
              name: "message",
              type: "textarea",
              placeholder: "Enter your message",
              value: item.message,
              attributes: {
                rows: 6,
                maxlength: 500,
              },
            },
          ],
          buttons: [
            {
              text: "Cancel",
              role: "cancel",
              cssClass: "alert-button-cancel",
              handler: () => {
                console.log("Edit cancelled");
              },
            },
            {
              text: "Update",
              cssClass: "alert-button-confirm",
              handler: (data) => {
                const trimmedMessage = data.message?.trim();

                if (!trimmedMessage) {
                  this.$ionic.toastController
                    .create({
                      message: "Message cannot be empty",
                      duration: 2000,
                      color: "danger",
                      position: "bottom",
                    })
                    .then((toast) => toast.present());
                  return false;
                }

                if (trimmedMessage === item.message) {
                  // No changes made
                  this.$ionic.toastController
                    .create({
                      message: "No changes detected",
                      duration: 1500,
                      color: "warning",
                      position: "bottom",
                    })
                    .then((toast) => toast.present());
                  return false;
                }

                // Update the message in store
                this.$store
                  .dispatch("updateCustomMessage", {
                    id: item.id,
                    message: trimmedMessage,
                  })
                  .then(() => {
                    this.$ionic.toastController
                      .create({
                        message: "Message updated successfully",
                        duration: 2000,
                        color: "success",
                        position: "bottom",
                      })
                      .then((toast) => toast.present());
                    this.$store.dispatch("fetchBuildingProfile");
                  })
                  .catch((error) => {
                    this.$ionic.toastController
                      .create({
                        message: "Failed to update message",
                        duration: 2000,
                        color: "danger",
                        position: "bottom",
                      })
                      .then((toast) => toast.present());
                    console.error("Error updating message:", error);
                  });
              },
            },
          ],
        })
        .then((a) => a.present());
    },

    deleteMessage(item) {
      console.log("Delete message:", item);
      // Add your delete logic here
      this.$ionic.alertController
        .create({
          header: "Delete Message",
          message: "Are you sure you want to delete this preset message?",
          buttons: [
            {
              text: "No",
              role: "cancel",
            },
            {
              text: "Yes",
              role: "destructive",
              handler: () => {
                // Dispatch delete action
                this.$store
                  .dispatch("deleteCustomMessage", item.id)
                  .then((response) => {
                    
                    console.log("✅ Delete SUCCESS:", response); // ✅ Debug

                    this.$ionic.toastController
                      .create({
                        message: "Message deleted successfully",
                        duration: 2000,
                        color: "success",
                        position: "bottom",
                      })
                      .then((toast) => toast.present());
                    this.$store.dispatch("fetchBuildingProfile");
                  })
                  .catch((error) => {
                    this.$ionic.toastController
                      .create({
                        message: "Failed to delete message",
                        duration: 2000,
                        color: "danger",
                        position: "bottom",
                      })
                      .then((toast) => toast.present());
                    console.error("Error deleting message:", error);
                  });
              },
            },
          ],
        })
        .then((a) => a.present());
    },
  },
};
